import { inject } from "vue"

export type ConfirmationOpenFunction = (
  title?: string,
  text?: string,
  confirmText?: string,
  cancelText?: string
) => Promise<boolean>

export class ConfirmationService {
  open({
    title,
    text,
    confirmText,
    cancelText,
    onConfirm,
  }: {
    title?: string
    text?: string
    confirmText?: string
    cancelText?: string
    onConfirm?: () => void
  }) {
    if (!this._callback) {
      throw new Error("No callback was registered in ConfirmationService")
    }
    return this._callback(title, text, confirmText, cancelText).then(
      (confirmed) => {
        if (confirmed && onConfirm) {
          onConfirm()
        }
        return confirmed
      }
    )
  }

  private _callback: ConfirmationOpenFunction
  registerCallback(callback: ConfirmationOpenFunction) {
    this._callback = callback
  }
}

export const useConfirmationService = (): ConfirmationService => {
  const confirmationService = inject("ConfirmationService")
  if (!confirmationService) {
    throw new Error(
      "ConfirmationService not provided, is 'ConfirmationDialogProvider' missing in a parent component?"
    )
  }
  return confirmationService as ConfirmationService
}
